import { render, staticRenderFns } from "./UserAvater.vue?vue&type=template&id=4774a7c2&scoped=true&v-if=user"
import script from "./UserAvater.vue?vue&type=script&lang=js"
export * from "./UserAvater.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4774a7c2",
  null
  
)

export default component.exports